import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { settingsAPI } from '../../services/api';
import { useAuth } from '../../context/AuthContext';
import './FeedbackGateToggle.css';

export default function FeedbackGateToggle() {
  const { isEditor } = useAuth();
  const [gateOpen, setGateOpen]     = useState(true);
  const [loading, setLoading]       = useState(true);
  const [toggling, setToggling]     = useState(false);
  const [updatedAt, setUpdatedAt]   = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await settingsAPI.getFeedbackGate();
        setGateOpen(res.data.feedback_open);
        setUpdatedAt(res.data.updated_at);
      } catch {
        // default open on error
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const handleToggle = async () => {
    if (!isEditor) return;
    setToggling(true);
    try {
      const res = await settingsAPI.toggleFeedbackGate();
      setGateOpen(res.data.feedback_open);
      setUpdatedAt(new Date().toISOString());
      toast.success(res.data.message);
    } catch {
      toast.error('Failed to update feedback gate');
    } finally {
      setToggling(false);
    }
  };

  if (loading) return null;

  return (
    <div className={`gate-card ${gateOpen ? 'gate-card--open' : 'gate-card--closed'}`}>
      <div className="gate-info">
        <div className="gate-icon">{gateOpen ? '✅' : '🔒'}</div>
        <div>
          <div className="gate-title">
            Feedback Portal
            <span className={`gate-badge ${gateOpen ? 'gate-badge--open' : 'gate-badge--closed'}`}>
              {gateOpen ? 'OPEN' : 'CLOSED'}
            </span>
          </div>
          <div className="gate-desc">
            {gateOpen
              ? 'Users can currently submit feedback.'
              : 'Feedback is closed. Users see a "closed for this semester" message.'}
          </div>
          {updatedAt && (
            <div className="gate-updated">
              Last changed: {new Date(updatedAt).toLocaleString()}
            </div>
          )}
        </div>
      </div>

      {isEditor && (
        <button
          className={`btn ${gateOpen ? 'btn-danger' : 'btn-primary'} gate-btn`}
          onClick={handleToggle}
          disabled={toggling}
        >
          {toggling
            ? 'Updating…'
            : gateOpen
              ? '🔒 Close Feedback'
              : '✅ Open Feedback'}
        </button>
      )}
    </div>
  );
}
